export const buildCompanyPatchBody = (payload) => {
  const body = {
    name_en: payload.name_en,
    city_id: payload.city_id,
    company_owner_attributes: payload.company_owner_attributes,
  };

  if (payload.name_ar !== undefined) {
    body.name_ar = payload.name_ar;
  }
  if (payload.image_url) {
    body.image_url = payload.image_url;
  }
  if (payload.commercial_record_url !== undefined) {
    body.commercial_record_url =
      payload.commercial_record_url === null
        ? ""
        : payload.commercial_record_url;
  }
  if (payload.commercial_record != null && payload.commercial_record !== "") {
    body.commercial_record = payload.commercial_record;
  }

  return body;
};
